/**
 * Axios Instance
 */

import request from '@bfe/air-request';

const instance = request();

export default instance;
